import { connect } from 'react-redux'

import { 
    PANTALLA_LIBRO_ID,
    PANTALLA_ANTERIOR_ID,
    actions, 
    selectors, 
    selectorsTextosUsuario,        
    TextosUsuario,
    selectorsBarraHerramientas
} from 'ibook-api'

import PantallaLibroDosPaginas from './../components/pantalla-libro-dos-paginas'
import PaginacionContainer from './paginacion-container';

const PantallaLibroDosPaginasContainer = connect(
    (state, ownProps) => {
        const pantallaProps = selectors.getPantallaProps(state)
        const libroId = ownProps.libroId || pantallaProps.libroId
        const numPagina = ownProps.numPagina || pantallaProps.numPagina

        const numPrimeraPagina = selectors.getPrimeraPagina(state, libroId)
        const numUltimaPagina = selectors.getUltimaPagina(state, libroId)

        /** pagina izquierda */
        const numPaginaIzquierda = selectors.getNumPaginaIzquierda(state, libroId, numPagina)
        const zonasPaginaIzquierda = selectors.getZonas(state, libroId, numPaginaIzquierda)
        const caminoPaginaIzquierda = selectors.getCaminoPagina(state, libroId, numPaginaIzquierda)
        caminoPaginaIzquierda && caminoPaginaIzquierda.hitos.forEach(hito => {
            const [tipo, numLibro, numPagina] = hito.vinculo.split(',')            
            hito.activo = (tipo === 'goto' 
                && libroId === selectors.getIdByNum(state, numLibro) 
                && numPaginaIzquierda === Number(numPagina)
            )
        })
        if(caminoPaginaIzquierda.marcarBotonCamino){
            for(let i=0;i<caminoPaginaIzquierda.marcarBotonCamino.length;i++){
                caminoPaginaIzquierda.hitos[parseInt(caminoPaginaIzquierda.marcarBotonCamino[i],10) - 1].activo = true
            }
        }
        const textosUsuarioPaginaIzquierda = selectorsTextosUsuario.getTextosPagina(state, libroId, numPaginaIzquierda)
        
        /** pagina derecha */
        const numPaginaDerecha = numPaginaIzquierda + 1
        const zonasPaginaDerecha = selectors.getZonas(state, libroId, numPaginaDerecha)    
        const caminoPaginaDerecha = selectors.getCaminoPagina(state, libroId, numPaginaDerecha)        
        caminoPaginaDerecha && caminoPaginaDerecha.hitos.forEach(hito => {
            const [tipo, numLibro, numPagina] = hito.vinculo.split(',')            
            hito.activo = (tipo === 'goto' 
                && libroId === selectors.getIdByNum(state, numLibro) 
                && numPaginaDerecha === Number(numPagina)
            )
        })
        if(caminoPaginaDerecha.marcarBotonCamino){
            for(let i=0;i<caminoPaginaDerecha.marcarBotonCamino.length;i++){
                caminoPaginaDerecha.hitos[parseInt(caminoPaginaDerecha.marcarBotonCamino[i],10) - 1].activo = true
            }
        }
        const textosUsuarioPaginaDerecha = selectorsTextosUsuario.getTextosPagina(state, libroId, numPaginaDerecha)


        const dimensionesBaja = selectors.getDimensionesBaja(state, libroId)
        const multiplicadorBaja = selectors.getMultiplicadorBaja(state, libroId)
        const configBotones = selectors.getConfigBotones(state)

        const configIndice =  selectors.getConfigIndice(state)

        // textos usuario
        const textosUsuarioVisible = selectors.getTextosUsuarioVisible(state)
        const modoCrearTextoUsuario = selectorsTextosUsuario.getModoCrear(state)
        
        const imagenUsuarioVisible = selectors.getImagenUsuarioVisible(state)

        // const textosUsuarioTextoAyuda = selectorsBarraHerramientas.getBoton(state, 'Texto').textoAyuda
        const configHerramientaTexto = selectorsBarraHerramientas.getBoton(state, 'Texto')
        const configHerramientaNota = selectorsBarraHerramientas.getBoton(state, 'Nota')
        const configHerramientaVinculo = selectorsBarraHerramientas.getBoton(state, 'Vinculo')

        const listaNavegacionLibros = selectors.getConfigLibros(state).listaNavegacionLibros

        const infoCaminos = selectors.getConfigCaminos(state)

        return {
            libroId,
            numPagina,
            numPaginaIzquierda,
            numPaginaDerecha,
            numPrimeraPagina,
            numUltimaPagina,

            dimensionesBaja,
            multiplicadorBaja,
            configBotones,

            zonasPaginaIzquierda,
            zonasPaginaDerecha,

            listaNavegacionLibros,
            infoCaminos,

            caminoPaginaIzquierda,
            caminoPaginaDerecha,

            configIndice,

            textosUsuarioPaginaIzquierda,
            textosUsuarioPaginaDerecha,
            // textosUsuarioTextoAyuda,

            textosUsuarioVisible,
            modoCrearTextoUsuario,
            configTextosUsuario: {
                [TextosUsuario.TIPO_TEXTO]: configHerramientaTexto,
                [TextosUsuario.TIPO_NOTA]: configHerramientaNota,
                [TextosUsuario.TIPO_VINCULO]: configHerramientaVinculo
            },

            imagenUsuarioVisible,
            
            Paginacion: PaginacionContainer
        }
    },
    (dispatch, ownProps) => ({
        /* regresa a la pantalla anterior */
        onIndice: (libroId) => dispatch(actions.pantalla(PANTALLA_ANTERIOR_ID, {libroId})),

        /* zona del libro */
        onZona: (libroId, numPagina, numZona) => dispatch(actions.zona(libroId, numPagina, numZona)),

        onNotas: () => dispatch(actions.notas()),

        /* textos de usuario */
        onCrearTextoUsuario: (tipo, x, y, textoHtml, libroId, numPagina) => {
            window.console.log('pantalla-libro-dos-paginas -> onCrearTextoUsuario', {
                tipo, x, y, textoHtml, numPagina, ownProps
            })
            dispatch (
                actions.crearTexto(
                    new TextosUsuario.Texto({
                        tipo, x, y, textoHtml, libroId, numPagina
                    })
                )
            )
        },
        onActualizarTextoUsuario: (textoId, valores) => dispatch(actions.actualizarTexto(textoId, valores)),

        /* para pasar de pagina */
        onPagina: numPagina => dispatch(actions.pantalla(PANTALLA_LIBRO_ID, {libroId: ownProps.libroId, numPagina}))
    })
)(PantallaLibroDosPaginas)

export default PantallaLibroDosPaginasContainer
